import * as React from 'react';
import { useDispatch } from 'react-redux';
import { AutoCompleteInput, DateTimeInput } from '../../../../components/form-elements/_index';
import { AutoCompleteItem } from '../../../../models/utilities/autocomplete-item';
import { FlyoutSaveCancel } from '../../../../components/flyout-components/FlyoutSaveCancel';
import { VendorSvc } from '../../../../shared/services/vendor-service';
import { DeliveryAddressesTable } from '../../../../shared/components/DeliveryAddressesTable';
import { StatusCode } from '../../../../utils/api';
import { ApiEndpoints, GlobalConstants } from '../../../../utils/app-constants';
import { ShipmentActionType } from '../../../models/enums/shipment-action-type';
import { BackhaulShipmentActionCreate } from '../../../models/shipments/shipment-action-create';
import { VendorAddress } from '../../../../shared/models/vendor-address';
import { TransportationSvc } from '../../../service';
import { ShipmentType } from '../../../models/enums/shipment-type';

interface IProps {
    entityType: ShipmentType;
    onSuccess: any;
    onCancel: any;
    truckId: number;
    truckVersion: string;
}

export const CreateBackhaulAction = (props : IProps) => {

    const dispatch                      = useDispatch();
    const [service]                     = React.useState(new VendorSvc());
    const [transport]                   = React.useState(new TransportationSvc());
    const [vendor, setVendor]           = React.useState<AutoCompleteItem>(new AutoCompleteItem());
    const [addressList, setAddressList] = React.useState<VendorAddress[]>([]);
    const [shipTo, setShipTo]           = React.useState<VendorAddress>();
    const [stopTime, setStopTime]       = React.useState<Date|undefined>(undefined);

    /**
     * Handle the dealer changing by kicking off a search for addresses
     * @param e the dealer ID
     */
    const onVendorChange = async (e : any) => {

        if (e) {
            setVendor(e);

            const result = await service.getVendorAddresses(e.id);
            if (result.status === StatusCode.Success) {
                setAddressList(result.data);
            }
        }
    };

    /**
     * Handle the dealer changing by kicking off a search for addresses
     * @param e the dealer ID
     */
    const onStopTimeChange = async (newDate : Date) => {
        setStopTime(newDate);
    };    

    /**
     * Updated the selected address
     * @param itm The ShipTo Address the user selected
     */
    const onAddressSelected = (itm : VendorAddress) => {
        if (itm) {
            setShipTo(itm);
        }
    };

    const onSave = async () => {

        if (shipTo) {
            const vm = new BackhaulShipmentActionCreate();
            vm.type = ShipmentActionType.Backhaul;
            vm.vendorId = vendor.id;
            vm.shipToAddressId = shipTo?.id;
            vm.stopTimeLocal = stopTime ? stopTime : null;
            vm.rowVersion = props.truckVersion;

            const result = await transport.addNewStop(vm, props.truckId, props.entityType);
            if (result.status === StatusCode.Success) {
                props.onSuccess();
            }
        }
    };

    return <div className="stop-create-content">

                <div className="row">
                    <div className="col-md-2">
                        <h2 className="step-label">Step<br/>1</h2>
                    </div>
                    <div className="col-md-10">
                        <h3 className="step-instruction">Pick a vendor</h3>
                        <AutoCompleteInput
                                id="edit-driver-asset"
                                label=""
                                onChange={ onVendorChange }
                                dispatch={ dispatch }
                                endpoint={ ApiEndpoints.VENDORS_AUTOCOMPLETE }
                                value={ vendor.name }
                                placeholder="Enter Vendor Name"
                            />
                    </div>
                </div>
                
                {
                    vendor && vendor.id.length > 0
                        ? <div className="row">
                            <div className="col-md-2">
                                <h2 className="step-label">Step<br/>2</h2>
                            </div>
                            <div className="col-md-10">
                                <h3 className="step-instruction">Pick an address</h3>
                                <div className="address-list-wrapper">
                                    <DeliveryAddressesTable
                                        addresses={ addressList }
                                        dealerId={ vendor?.id }
                                        enableLink={ false }
                                        onClick={ onAddressSelected }
                                    />
                                </div>
                            </div>
                        </div>
                        : null
                }

                {
                    shipTo
                        ? <div className="row">
                            <div className="col-md-2">
                                <h2 className="step-label">Step<br/>3</h2>
                            </div>
                            <div className="col-md-10">
                                <h3 className="step-instruction">Set a Stop Time</h3>
                                <DateTimeInput
                                    id="stopTime"
                                    format={ GlobalConstants.ABBR_LONG_DATE }
                                    value={ stopTime }
                                    showTimezone={ true }
                                    timezone={ shipTo.address.timeZoneId }
                                    label=""
                                    onChange={ onStopTimeChange }
                                />
                            </div>
                        </div>
                        : null
                }

                <FlyoutSaveCancel
                    onSave={ onSave }
                    onCancel={ props.onCancel }
                />
  
            </div>;
};
